import { Type } from '@scalar/typebox';
import { getResolvedRef, mergeSiblingReferences } from './helpers/get-resolved-ref.js';
import { compose } from './schemas/compose.js';
import { coerceValue } from './schemas/typebox-coerce.js';
import { SchemaObjectSchema } from './schemas/v3.2/strict/openapi-document.js';
/**
 * The coercion target: a schema object that may still carry the `$ref` it was resolved from.
 *
 * `Type.Composite` merges every property of `SchemaObjectSchema` to build this, so it belongs at module
 * scope. `resolve.schema` runs once per property of every schema a render walks, and rebuilding the
 * composite per call dominated that walk.
 */
const resolvedSchemaSchema = compose(SchemaObjectSchema, Type.Object({ $ref: Type.Optional(Type.String()) }));
export const resolve = {
    schema: (schema) => {
        if (schema === undefined) {
            return undefined;
        }
        const resoled = getResolvedRef(schema, mergeSiblingReferences);
        return coerceValue(resolvedSchemaSchema, resoled);
    },
};
